class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    const facetForm = this.querySelector("form");
    if (facetForm.dataset.isApplyActive !== "true") {
      facetForm.addEventListener("input", (event) => {
        setTimeout(() => {
          FacetFiltersForm.onSubmitHandler(event);
        }, 100);
      });
    }
    if (this.dataset.fetchBackendFilters) {
      fetch(this.dataset.fetchBackendFilters)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );
          const filtersWrapper = html.getElementById("filters-wrapper");
          if (!filtersWrapper) return;
          document.getElementById("filters-wrapper").innerHTML =
            filtersWrapper.innerHTML;
        });
    }
    if (this.dataset.loadOnStart) {
      document.addEventListener("DOMContentLoaded", (event) => {
        const searchParams = FacetFiltersForm.createSearchParams(facetForm);
        FacetFiltersForm.renderPage(searchParams, event, false);
      });
    }

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

    FacetFiltersForm.initApplyClear();
  }

  static initApplyClear() {
    FacetFiltersForm.filterApplyButtons =
      document.querySelectorAll(".js-filter-apply");
    FacetFiltersForm.filterClearButtons =
      document.querySelectorAll(".js-filter-clear");
    FacetFiltersForm.details = document.querySelectorAll(
      "#FacetsWrapperDesktop details",
    );

    FacetFiltersForm.filterApplyButtons.forEach((element) =>
      element.addEventListener("mousedown", (e) => {
        const details = element.closest("details");
        if (details) {
          details.querySelector("summary").click();
          const moreDetails = details.parentNode.closest("details");
          if (moreDetails) moreDetails.querySelector("summary").click();
          const priceRangeSlider = details.querySelector("price-range-slider");
          if (priceRangeSlider) {
            priceRangeSlider.updateInputValues();
            priceRangeSlider.syncWithOtherRangeSliders();
          }
        }

        FacetFiltersForm.onSubmitHandler(e);
      }),
    );

    document.addEventListener("mousedown", (event) => {
      if (event.target.closest("details") == null) {
        FacetFiltersForm.details.forEach((detail) => {
          detail.removeAttribute("open");
        });
      }
    });

    FacetFiltersForm.details.forEach((element) => {
      element.addEventListener("mousedown", (event) => {
        FacetFiltersForm.details.forEach((detail) => {
          if (
            detail !== event.target &&
            event.target.closest("details") != detail
          )
            detail.removeAttribute("open");
        });
      });
    });

    FacetFiltersForm.filterClearButtons.forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();

        const details = element.closest("details");
        if (!details) return;
        details.removeAttribute("open");

        const drawer = element.closest("filter-drawer");
        if (drawer) {
          drawer.closeSubmenu(details);
          drawer.closeMenuDrawer(event);
        }

        // if a normal filter
        const fieldset = details.querySelector("fieldset");
        if (fieldset) {
          const inputs = fieldset.querySelectorAll("input");
          inputs.forEach((input) => {
            input.checked = false;
          });
          FacetFiltersForm.onSubmitHandler(event);
        }

        // if a price range filter
        const priceRangeSlider = details.querySelector("price-range-slider");
        if (priceRangeSlider) {
          priceRangeSlider.reset();
          const remover = document.querySelector("#price-range-remove a");
          if (!remover) return;
          remover.click();
        }

        // if sort by
        const sortBy = details.querySelector("[name='sort_by']");
        const sortByMobile = details.querySelector("[name='sort_by_mobile']");
        if (sortBy || sortByMobile) {
          const remover = document.querySelector("sort-remove");
          if (!remover) return;
          remover.click();
        }
      });
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, event, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("animate-pulse");

    const isColorFiltered = new URLSearchParams(searchParams).has(
      "filter.p.m.custom.fabric_color",
    );

    console.log(isColorFiltered);
    console.log("SECTIONS: ", sections);
    sections.forEach((section) => {
      const pathName = isColorFiltered
        ? window.location.pathname.replace(
            /\/([^\/]+)$/,
            `/${section.backendHandle ? section.backendHandle : section.handle}`,
          )
        : window.location.pathname.replace(/\/([^\/]+)$/, `/${section.handle}`);

      const selectors = {
        source: isColorFiltered
          ? ".productsGrid"
          : `[data-handle="${section.handle}"]`,
        target: `[data-handle="${section.handle}"]`,
      };

      const url = window.location.pathname.includes("/search")
        ? `${pathName}?section_id=main-search&${searchParams}`
        : `${pathName}?section_id=api-collection-paginated-feed&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(
            filterDataUrl,
            event,
            selectors,
          )
        : FacetFiltersForm.renderSectionFromFetch(url, event, selectors);
    });
    const gridContainer = document.getElementById("ProductGridContainer");

    // render filters separately via current collection
    const filterUrl = `${window.location.pathname}?section_id=${gridContainer.dataset.id}&${searchParams}`;
    const filterDataUrl = (element) => element.url === filterUrl;
    const filterHtml = FacetFiltersForm.filterData.find(filterDataUrl);
    if (filterHtml) {
      FacetFiltersForm.renderFilters(filterHtml.html, event);
    } else {
      fetch(filterUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          FacetFiltersForm.filterData = [
            ...FacetFiltersForm.filterData,
            { html, filterUrl },
          ];
          FacetFiltersForm.renderFilters(html, event);
        });
    }

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    document.querySelector("filter-drawer").closeMenuDrawer(event);
  }

  static renderSectionFromFetch(url, event, selectors) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderProductGridContainer(html, selectors);
        // FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event, selectors) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderProductGridContainer(html, selectors);
    // FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html, selectors) {
    const grid = document.querySelector(selectors.target);
    const newDom = new DOMParser().parseFromString(html, "text/html");
    grid.innerHTML = newDom.querySelector(selectors.source).innerHTML;
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.remove("animate-pulse");
    document.querySelectorAll(".productsGrid").forEach((group) => {
      if (group.children.length === 0) {
        document.getElementById(group.dataset.handle)?.classList.add("hidden");
        group.classList.add("hidden");
      } else {
        document
          .getElementById(group.dataset.handle)
          ?.classList.remove("hidden");
        group.classList.remove("hidden");
      }
    });
    const searchTitle = document.querySelector("#search-title");
    if (searchTitle) {
      searchTitle.innerHTML = newDom.querySelector("#search-title").innerHTML;
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );
    const matchesIndex = (newFilter) => {
      const currentFilter = event
        ? event.target.closest(".js-filter")
        : undefined;
      return currentFilter
        ? newFilter.dataset.index === currentFilter.dataset.index
        : false;
    };
    let facetsToRender = event.target.closest("#FacetFiltersFormMobile")
      ? facetDetailsElements
      : Array.from(facetDetailsElements).filter(
          (element) => !matchesIndex(element),
        );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    FacetFiltersForm.initApplyClear();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("filter-drawer")
      .bindEvents();
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    let sections = [];
    const sectionElements = document.querySelectorAll(".productsGrid");
    sectionElements.forEach((element) => {
      sections.push({
        handle: element.dataset.handle,
        backendHandle: element.dataset.backendHandle,
      });
    });

    return sections;
  }

  static createSearchParams(form) {
    const formData = new FormData(form);
    let cleanFormData = [];
    for (let [key, value] of formData.entries()) {
      if (
        value == "" ||
        value == null ||
        value == undefined ||
        (value == "0" && value == 0)
      )
        continue;
      if (value == window.default_sort_by) continue;
      if (value == "relevance") continue;
      if (
        key.includes("price") &&
        value === form.querySelector("price-range-slider").dataset.maxLimit
      )
        continue;
      if (key.includes("fake")) {
        key = key.replace("_fake", "");
      }
      if (cleanFormData.some((item) => item[1] === value)) continue;

      cleanFormData.push([key, value]);
    }
    // if on search page, get q parameter from the url and add
    if (
      window.location.pathname.includes("/search") &&
      cleanFormData.some((item) => item[0] === "q") === false
    ) {
      const urlParams = new URLSearchParams(window.location.search);
      const q = urlParams.get("q");
      if (q) cleanFormData.push(["q", q]);
    }

    const params = new URLSearchParams(cleanFormData);
    return params.toString();
  }

  static onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  static onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest("form");
    const params = FacetFiltersForm.createSearchParams(form);

    FacetFiltersForm.onSubmitForm(params, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );
    FacetFiltersForm.renderPage(url, event);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);
class SortRemove extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.closeFilter.bind(this));
    this.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
    document.querySelectorAll(".sortRemove").forEach((element) => {
      element.addEventListener("click", this.closeFilter.bind(this));
    });
  }

  closeFilter(event) {
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    const paramsWithoutSorBy = new URLSearchParams(
      FacetFiltersForm.createSearchParams(this.closest("form")),
    );
    paramsWithoutSorBy.delete("sort_by");
    FacetFiltersForm.searchParamsPrev = paramsWithoutSorBy.toString();
    FacetFiltersForm.renderPage(FacetFiltersForm.searchParamsPrev, event);

    const drawer = document.querySelector("filter-drawer");
    const details = event.target.closest("details");
    details && drawer.closeSubmenu(details);
    drawer.closeMenuDrawer(event);
  }
}

customElements.define("sort-remove", SortRemove);
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}
document.querySelectorAll("details > details").forEach((child) => {
  child.addEventListener("click", (event) => {
    event.stopPropagation(); // This stops the event from bubbling up to the parent
  });
});
class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button:not(.dropdown-trigger)").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    const input = summaryElement.querySelector("input");
    if (input) input.checked = !input.checked;

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(`overflow-hidden`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 1) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("filter-drawer", MenuDrawer);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  // summary.setAttribute("role", "button");
  // summary.setAttribute(
  //   "aria-expanded",
  //   summary.parentNode.hasAttribute("open")
  // );
  // if (summary.nextElementSibling.getAttribute("id")) {
  //   summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  // }
  // summary.addEventListener("click", (event) => {
  //   event.currentTarget.setAttribute(
  //     "aria-expanded",
  //     !event.currentTarget.closest("details").hasAttribute("open")
  //   );
  // });
  // if (summary.closest("header-drawer, menu-drawer")) return;
  // summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function trapFocus(container, elementToFocus = container) {
  // var elements = getFocusableElements(container);
  // var first = elements[0];
  // var last = elements[elements.length - 1];
  // removeTrapFocus();
  // trapFocusHandlers.focusin = (event) => {
  //   if (
  //     event.target !== container &&
  //     event.target !== last &&
  //     event.target !== first
  //   )
  //     return;
  //   document.addEventListener("keydown", trapFocusHandlers.keydown);
  // };
  // trapFocusHandlers.focusout = function () {
  //   document.removeEventListener("keydown", trapFocusHandlers.keydown);
  // };
  // trapFocusHandlers.keydown = function (event) {
  //   if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
  //   // On the last focusable element and tab forward, focus the first element.
  //   if (event.target === last && !event.shiftKey) {
  //     event.preventDefault();
  //     first.focus();
  //   }
  //   //  On the first focusable element and tab backward, focus the last element.
  //   if (
  //     (event.target === container || event.target === first) &&
  //     event.shiftKey
  //   ) {
  //     event.preventDefault();
  //     last.focus();
  //   }
  // };
  // document.addEventListener("focusout", trapFocusHandlers.focusout);
  // document.addEventListener("focusin", trapFocusHandlers.focusin);
  // elementToFocus.focus();
  // if (
  //   elementToFocus.tagName === "INPUT" &&
  //   ["search", "text", "email", "url"].includes(elementToFocus.type) &&
  //   elementToFocus.value
  // ) {
  //   elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  // }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  // const navKeys = [
  //   "ARROWUP",
  //   "ARROWDOWN",
  //   "ARROWLEFT",
  //   "ARROWRIGHT",
  //   "TAB",
  //   "ENTER",
  //   "SPACE",
  //   "ESCAPE",
  //   "HOME",
  //   "END",
  //   "PAGEUP",
  //   "PAGEDOWN",
  // ];
  // let currentFocusedElement = null;
  // let mouseClick = null;
  // window.addEventListener("keydown", (event) => {
  //   if (navKeys.includes(event.code.toUpperCase())) {
  //     mouseClick = false;
  //   }
  // });
  // window.addEventListener("mousedown", (event) => {
  //   mouseClick = true;
  // });
  // window.addEventListener(
  //   "focus",
  //   () => {
  //     if (currentFocusedElement)
  //       currentFocusedElement.classList.remove("focused");
  //     if (mouseClick) return;
  //     currentFocusedElement = document.activeElement;
  //     currentFocusedElement.classList.add("focused");
  //   },
  //   true
  // );
}

function removeTrapFocus(elementToFocus = null) {
  // document.removeEventListener("focusin", trapFocusHandlers.focusin);
  // document.removeEventListener("focusout", trapFocusHandlers.focusout);
  // document.removeEventListener("keydown", trapFocusHandlers.keydown);
  // if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  // if (event.code.toUpperCase() !== "ESCAPE") return;
  // const openDetailsElement = event.target.closest("details[open]");
  // if (!openDetailsElement) return;
  // const summaryElement = openDetailsElement.querySelector("summary");
  // openDetailsElement.removeAttribute("open");
  // summaryElement.setAttribute("aria-expanded", false);
  // summaryElement.focus();
}

/**
 * Price Range Slider
 * @class
 * @extends HTMLElement
 * This class is responsible for rendering the price range slider
 * and handling the drag functionality.
 * It takes the min and max values from the data attributes
 * and renders the slider accordingly.
 */
class PriceRangeSlider extends HTMLElement {
  static observedAttributes = ["data-min-limit", "data-max-limit"];

  constructor() {
    super();
    this.minInput = this.querySelector('input[name$="gte"]');
    this.maxInput = this.querySelector('input[name$="lte"]');
  }

  connectedCallback() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.init();
          observer.disconnect();
        }
      });
    });
    observer.observe(this);
  }

  init() {
    this.getValues();
    this.initSlider();
    this.initDragFunctionality();
    this.afterInit();
    this.updateOnInputChange();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (!this.isSource) return;
    if (!oldValue) return;
    if (name === "data-min-limit" || name === "data-max-limit") {
      this.getValues();
      this.minInput.dispatchEvent(new Event("change"));
      this.maxInput.dispatchEvent(new Event("change"));
    }
  }

  afterInit() {
    this.updateKnobValues();
    this.updateInputValues();
  }

  getValues() {
    this.minLimit = parseInt(this.dataset.minLimit) || 0;
    this.maxLimit = parseInt(this.dataset.maxLimit) || 1000;

    this.minLimit =
      this.minLimit > this.maxLimit ? this.maxLimit : this.minLimit;
    this.maxLimit =
      this.maxLimit < this.minLimit ? this.minLimit : this.maxLimit;
  }

  initSlider() {
    /**
     * We render the slider using JS to avoid manual work.
     * This function creates the slider elements and appends them to the DOM.
     */
    const sliderContainer = document.createElement("div");
    sliderContainer.className = "relative w-full h-10";

    const knobClass =
      "absolute w-4 h-4 border bg-white border-accent shadow active:border-10 top-1/2 -translate-y-1/2 rounded-full cursor-pointer after:absolute after:bottom-full after:left-1/2 after:-translate-x-1/2 after:pb-2 after:text-sm before:absolute before:w-12 before:h-12 before:left-1/2 before:top-1/2 before:-translate-y-1/2 before:-translate-x-1/2";

    const minKnob = document.createElement("div");
    minKnob.className = knobClass + " after:content-[attr(data-value)]";
    minKnob.style.left = this.calculateKnobPosition(this.minInput.value) + "%";
    this.minKnob = minKnob;

    const maxKnob = document.createElement("div");
    maxKnob.className = knobClass + " after:content-[attr(data-value)]";
    maxKnob.style.right =
      100 - this.calculateKnobPosition(this.maxInput.value) + "%";
    this.maxKnob = maxKnob;

    const line = document.createElement("div");
    line.className =
      "absolute w-full h-0.5 bg-accent top-1/2 transform -translate-y-1/2";

    const activeLine = document.createElement("div");
    activeLine.className =
      "absolute h-1 bg-accent top-1/2 transform -translate-y-1/2";
    this.activeLine = activeLine;

    sliderContainer.append(line, activeLine, minKnob, maxKnob);
    this.append(sliderContainer);

    // we need to get the rect of the slider container to calculate the knob position later
    this.rect = sliderContainer.getBoundingClientRect();
  }

  initDragFunctionality() {
    // adds event listeners to the slider elements for drag functionality
    this.isDragging = false;
    this.currentKnob = null;

    this.minKnob.addEventListener("mousedown", (e) =>
      this.startDrag(e, this.minKnob),
    );
    this.maxKnob.addEventListener("mousedown", (e) =>
      this.startDrag(e, this.maxKnob),
    );

    this.minKnob.addEventListener("touchstart", (e) =>
      this.startDrag(e, this.minKnob),
    );

    this.maxKnob.addEventListener("touchstart", (e) =>
      this.startDrag(e, this.maxKnob),
    );

    this.minKnob.addEventListener("mousemove", this.doDrag.bind(this));
    this.minKnob.addEventListener("mouseup", this.endDrag.bind(this));
    this.maxKnob.addEventListener("mousemove", this.doDrag.bind(this));
    this.maxKnob.addEventListener("mouseup", this.endDrag.bind(this));

    this.minKnob.addEventListener("touchmove", this.doDrag.bind(this));
    this.minKnob.addEventListener("touchend", this.endDrag.bind(this));
    this.maxKnob.addEventListener("touchmove", this.doDrag.bind(this));
    this.maxKnob.addEventListener("touchend", this.endDrag.bind(this));
  }

  startDrag(e, knob) {
    // sets the current knob and starts the drag
    e.preventDefault();
    this.isDragging = true;
    this.currentKnob = knob;
  }

  doDrag(e) {
    // if we are not dragging, we don't need to do anything
    if (!this.isDragging) return;

    let clientX = e.clientX || e.touches[0].clientX;

    // calculates the new left percentage of the knob
    let newLeft = Math.max(
      0,
      Math.min(
        this.rect.width,
        clientX - this.rect.left - this.currentKnob.offsetWidth / 2,
      ),
    );
    let newRight = Math.max(
      0,
      Math.min(
        this.rect.width,
        this.rect.width -
          (clientX - this.rect.left) -
          this.currentKnob.offsetWidth / 2,
      ),
    );

    // if the new left position is out of bounds, we set it to the min or max value
    if (
      this.currentKnob === this.minKnob &&
      newLeft > parseInt(this.maxKnob.offsetLeft)
    ) {
      newLeft = parseInt(this.maxKnob.offsetLeft);
    } else if (
      this.currentKnob === this.maxKnob &&
      newLeft < parseInt(this.minKnob.offsetLeft)
    ) {
      newRight = parseInt(this.minKnob.offsetRight);
    }

    // we set the new left position of the knob
    if (this.currentKnob === this.minKnob) {
      this.currentKnob.style.left = newLeft + "px";
    } else {
      this.currentKnob.style.right = newRight + "px";
    }

    this.updateKnobValues();
  }

  endDrag() {
    // sets the isDragging to false and currentKnob to null
    this.isDragging = false;
    this.currentKnob = null;

    // if not using the apply button, do the deed on drag end
    debounce(this.updateInputValues(), 1000);
    debounce(this.syncWithOtherRangeSliders(), 1000);
    debounce(this.closest("form").dispatchEvent(new Event("input")), 1000);
    setTimeout(() => {
      this.updateInputValues();
      this.syncWithOtherRangeSliders();
    }, 1000);
  }

  updateActiveLine() {
    // updates the active line in between the knobs
    this.activeLine.style.left =
      parseInt(this.minKnob.offsetLeft) + this.minKnob.offsetWidth / 2 + "px";
    this.activeLine.style.right =
      parseInt(this.rect.width) -
      parseInt(this.maxKnob.offsetLeft) -
      this.maxKnob.offsetWidth / 2 +
      "px";
  }

  getKnobMoneyValue(knob) {
    // returns the money value of the knob without the currency symbol
    let percentage =
      knob === this.minKnob
        ? parseInt(knob.offsetLeft) / this.rect.width
        : (parseInt(knob.offsetLeft) + knob.offsetWidth) / this.rect.width;
    let value = Math.round(
      this.minLimit + (this.maxLimit - this.minLimit) * percentage,
    );
    if (this.rect.width === 0) {
      percentage = 0;
      value = 0;
    }
    return value;
  }

  updateKnobValues() {
    // updates the visible values on the knobs
    this.minKnob.dataset.value = "$" + this.getKnobMoneyValue(this.minKnob);
    this.maxKnob.dataset.value = "$" + this.getKnobMoneyValue(this.maxKnob);

    this.updateActiveLine();
    if (this.closest("form").dataset.isApplyActive === "true") {
      this.updateApplyButton();
    }
  }

  updateApplyButton() {
    const filter = this.closest(".js-filter");
    if (!filter) return;
    const clearApplyButtons = filter.querySelectorAll(".js-filter-apply");
    if (this.isKnobsReset()) {
      clearApplyButtons.forEach((button) => (button.disabled = true));
      const remover = document.querySelector("#price-range-remove a");
      if (!remover) return;
      remover.click();
    } else {
      clearApplyButtons.forEach((button) => (button.disabled = false));
    }
  }

  isKnobsReset() {
    return (
      this.minKnob.offsetLeft === 0 &&
      this.maxKnob.offsetLeft === this.rect.width - this.maxKnob.offsetWidth
    );
  }

  updateInputValues() {
    this.minInput.value = this.getKnobMoneyValue(this.minKnob);
    this.maxInput.value = this.getKnobMoneyValue(this.maxKnob);

    if (this.minInput.value === "0") this.minInput.value = "";
    if (parseInt(this.maxInput.value) === this.maxLimit)
      this.maxInput.value = "";
  }

  updateOnInputChange() {
    const onInputChange = (e, knob) => {
      let newValue = parseInt(e.target.value);

      // control min/max limits
      if (newValue > this.maxLimit) {
        newValue = this.maxLimit;
        e.target.value = newValue;
      } else if (newValue < this.minLimit) {
        newValue = this.minLimit;
        e.target.value = newValue;
      }

      // control min/max to not overlap
      if (knob === this.minKnob && newValue > this.maxInput.value) {
        newValue =
          newValue > this.maxLimit ? this.maxLimit : this.maxInput.value;
        e.target.value = newValue;
      } else if (knob === this.maxKnob && newValue < this.minInput.value) {
        newValue = this.minInput.value;
        e.target.value = newValue;
      }

      if (knob === this.minKnob)
        knob.style.left = this.calculateKnobPosition(newValue) + "%";
      if (knob === this.maxKnob)
        knob.style.right = 100 - this.calculateKnobPosition(newValue) + "%";
      this.updateKnobValues();
    };

    const debouncedOnInputChange = debounce(onInputChange, 750);

    this.minInput.addEventListener("input", (e) =>
      debouncedOnInputChange(e, this.minKnob),
    );
    this.maxInput.addEventListener("input", (e) =>
      debouncedOnInputChange(e, this.maxKnob),
    );
    this.minInput.addEventListener("change", (e) =>
      onInputChange(e, this.minKnob),
    );
    this.maxInput.addEventListener("change", (e) =>
      onInputChange(e, this.maxKnob),
    );
  }

  reset() {
    this.minInput.removeAttribute("value");
    this.maxInput.removeAttribute("value");
    this.minKnob.style.left = "0%";
    this.maxKnob.style.right = "0%";
    this.updateKnobValues();
  }

  syncWithOtherRangeSliders() {
    // find all range sliders and filter this one out using filter()
    const otherRangeSliders = [
      ...document.querySelectorAll("price-range-slider"),
    ].filter((slider) => slider !== this);

    // loop through the other range sliders and update the min and max values
    // otherRangeSliders.forEach((slider) => {
    //   slider.minInput.value = this.minInput.value;
    //   slider.maxInput.value = this.maxInput.value;
    // });
  }

  updateKnobByInput(e, knob) {}

  calculateKnobPosition(value) {
    const percentage =
      ((value - this.minLimit) / (this.maxLimit - this.minLimit)) * 100;
    return percentage;
  }
}
window.customElements.define("price-range-slider", PriceRangeSlider);

// document.querySelectorAll('.fake-sort-by').forEach((fake, index) => {
//   fake.addEventListener('click', (e) => {
//     const realSortBys = document.querySelectorAll('input[name="sort_by"]')
//     realSortBys[index].click()
//   });
// })
